import { StepInfo } from 'src/module/FormKit/model';
import { RefillFormData, RefillFormState } from '../model';
import {
  ClientInformation,
  Confirmation,
  NotificationSettings,
  PatientInfo
} from 'src/module/FormKit/components';
import { clientSchema, notificationSchema, patientSchema } from 'src/module/FormKit/validators';
import { REFILL_STEPS } from './productSteps';
import { additionalInfoSchema, validationSchema } from './productValidation';
import ProductInfoSection from '../components/ProductInfoSection';
import RefillStatus from '../components/RefillStatus';

export const PRODUCT_STEP_INFO: StepInfo<REFILL_STEPS, RefillFormData, RefillFormState> = {
  [REFILL_STEPS.CLIENT_INFO]: {
    title: 'section.clientInfo',
    field: 'clientInfo',
    validator: (data) => clientSchema.isValidSync(data.clientInfo),
    key: REFILL_STEPS.CLIENT_INFO,
    component: ClientInformation
  },
  [REFILL_STEPS.PATIENT_INFO]: {
    title: 'section.patientInfo',
    field: 'patientInfo',
    validator: (data) => patientSchema.isValidSync(data.patientInfo),
    key: REFILL_STEPS.PATIENT_INFO,
    component: PatientInfo
  },
  [REFILL_STEPS.ADDITIONAL_INFO]: {
    title: 'section.productInfo',
    field: 'additionalInfo',
    validator: (data) => additionalInfoSchema.isValidSync(data.additionalInfo),
    key: REFILL_STEPS.ADDITIONAL_INFO,
    component: ProductInfoSection
  },
  [REFILL_STEPS.NOTIFICATION_SETTINGS]: {
    title: 'section.notificationSettings',
    field: 'notificationSettings',
    validator: (data) => notificationSchema.isValidSync(data.notificationSettings),
    key: REFILL_STEPS.NOTIFICATION_SETTINGS,
    component: NotificationSettings
  },
  [REFILL_STEPS.CONFIRMATION]: {
    title: 'section.confirmation',
    field: null,
    validator: (data) => validationSchema.isValidSync(data),
    key: REFILL_STEPS.CONFIRMATION,
    component: Confirmation
  },
  [REFILL_STEPS.STATUS]: {
    title: 'section.status',
    field: null,
    validator: () => true,
    key: REFILL_STEPS.STATUS,
    component: RefillStatus
  }
};
